/* @flow */
import type AppState from "nexia_mobile/models/app_state";
import type Session from "nexia_mobile/models/session";
import type { DateString, HumanReadableString } from "nexia_mobile/api/types";
import type { XR724EnrollmentWizardState } from "nexia_mobile/components/Wizard/XR724EnrollmentWizard";
import type { XR724WifiConfigurationWizardState } from "nexia_mobile/components/Wizard/XR724WifiConfigurationWizard";
import type { DragonflyEnrollmentWizardState } from "nexia_mobile/components/Wizard/DragonflyEnrollmentWizard";
import type { DragonflyWifiConfigurationWizardState } from "nexia_mobile/components/Wizard/DragonflyWifiConfigurationWizard";

type State = {|
  appState: ?AppState,
  session: ?Session,
  showAlertsBadge: boolean,
  isAuthAttemptLockedOut: boolean,
  isNetworkConnected: boolean | typeof undefined,
  isAppPaused: boolean,
  appLastPausedAt: ?number, // unix timestamp (ms)
  xr724Enrollment: XR724EnrollmentWizardState,
  xr724WifiConfiguration: XR724WifiConfigurationWizardState,
  dragonflyEnrollment: DragonflyEnrollmentWizardState,
  dragonflyWifiConfiguration: DragonflyWifiConfigurationWizardState,
  locationPolling: {
    disableStack: number,
  },
  vognition: {
    listenOnStartupPending: boolean,
    isMicrophoneButtonActive: boolean,
    isMicrophoneButtonLoading: boolean,
  },
  newsDialogOpen: boolean,
  forceChoiceDialogOpen: boolean,
  isScreenReaderRunning: boolean,
  userCancelledFingerprint: boolean,
  backgroundLoading: boolean,
  isPlayingVideo: boolean,
  demoModeEvents: {
    [filter: string]: Array<{
      device_name: HumanReadableString,
      user_name: HumanReadableString,
      description: HumanReadableString,
      occurred_at: DateString,
    }>,
  },
  currentlyPollingEnrollmentStatus: boolean,
  spinnerShown: boolean,
  spinnerMessage: ?string,
  resetPasswordCode: ?string,
|};

const initialState: State = {
  appState: null,
  session: null,
  showAlertsBadge: false,
  isAuthAttemptLockedOut: false,
  isNetworkConnected: undefined,
  isAppPaused: false,
  appLastPausedAt: null,
  xr724Enrollment: {
    detailsHaveBeenFetched: false,
    pin: null,
    statusUrl: null,
    childSchemaLink: null,
    cancelLink: null,
    wizardExpiresAt: null,
    userKey: null,
    networks: null,
    chosenNetwork: null,
    errorMessage: null,
    isErrorRecoverable: true,
  },
  xr724WifiConfiguration: {
    userKey: null,
    networks: null,
    chosenNetwork: null,
  },
  dragonflyEnrollment: {
    detailsHaveBeenFetched: false,
    pin: null,
    statusUrl: null,
    cancelLink: null,
    wizardExpiresAt: null,
    networks: null,
    chosenNetwork: null,
    errorMessage: null,
    isErrorRecoverable: true,
  },
  dragonflyWifiConfiguration: {
    networks: null,
    chosenNetwork: null,
  },
  locationPolling: {
    disableStack: 0,
  },
  vognition: {
    listenOnStartupPending: true,
    isMicrophoneButtonActive: false,
    isMicrophoneButtonLoading: false,
  },
  newsDialogOpen: false,
  forceChoiceDialogOpen: false,
  isScreenReaderRunning: false,
  userCancelledFingerprint: false,
  backgroundLoading: false,
  isPlayingVideo: false,
  demoModeEvents: {},
  currentlyPollingEnrollmentStatus: false,
  spinnerShown: false,
  spinnerMessage: undefined,
  resetPasswordCode: undefined,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/flux_like/store/initial_state.js